"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledOrderedList = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledOrderedList = _styledComponents.default.div.withConfig({
  displayName: "OrderedListstyles__StyledOrderedList",
  componentId: "uyfnsn-0"
})([".c-ordered-list-item-wrapper{display:flex;}.c-ordered-list-item{padding:1rem 0 1rem 0;}"]);

exports.StyledOrderedList = StyledOrderedList;